export interface FooterProps {}

export const useFooter = (props: FooterProps) => {
  return {
    ...props,
  }
}
